import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { DefaultPolicyConfigLinkWrapper } from '../../../components/legacy-policy-panel'

const Wrapper = ({ invokedLink, organizationUuid }) => {
  return (
    <DefaultPolicyConfigLinkWrapper
      organizationUuid={organizationUuid}
      invokedLink={invokedLink}
    />
  )
}

export const reactDefaultPolicyConfigLink = createNgReactBridgeDirective(
  'reactDefaultPolicyConfigLink',
  [],
  Wrapper,
  ['invokedLink', 'organizationUuid']
)
